import { useTranslation } from 'react-i18next'
import { IBuffetMilletDto } from 'core/api/dto/BuffetMilletDto'

export interface IMilletProps {
  data: IBuffetMilletDto
  onClick: () => void
  currentMillet?: number
}

export const FrozeMillet = ({ data, onClick, currentMillet }: IMilletProps) => {
  const { t } = useTranslation()
  return (
    <div
      className={`millet-item ${currentMillet === data.id ? 'active' : ''}`}
      onClick={onClick}
    >
      <div
        className="time-category-wrapper"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div>
          <div className="millet-item__subtitle">
            <span> {t('Наименование тары')}</span>
          </div>
          <div className="millet-item__title">{data?.milletName}</div>
          <div className="millet-item__text ">
            <span>{`${data?.milletWeight} ${t('кг')}`}</span>
          </div>
        </div>
        <div className="millet-img">
          {!!(data.milletPhotoOnS3 || data.milletPhoto) ? (
            <img
              src={
                data.milletPhotoOnS3
                  ? data.milletPhotoOnS3
                  : data.milletPhoto || ''
              }
              alt=""
            />
          ) : (
            <i className="an-ico an-ico-photo-add " />
          )}
        </div>
      </div>
    </div>
  )
}
